import { Anchor, Button, Group } from "@mantine/core";
import { useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router";

import { PuzzleGame } from "../components/PuzzleGame";
import { useRandomBlendPuzzle } from "../hooks/useRandomBlendPuzzle";
import { newRandomBlendSeed } from "../puzzle";

/**
 * `/blend/:seed` — an off-calendar blend derived from the URL seed.
 * Deterministic, so the URL is shareable and reload-stable; attempts
 * persist under their own `random-<seed>` storage slot.
 */
export function RandomBlend() {
  const { seed = "" } = useParams();
  const puzzle = useRandomBlendPuzzle(seed);
  const navigate = useNavigate();

  const playAnother = useCallback(() => {
    void navigate(`/blend/${newRandomBlendSeed()}`);
  }, [navigate]);

  return (
    <PuzzleGame
      puzzle={puzzle}
      heading="random blend"
      blendLabel="random blend"
      metaLabel={() => `random blend · ${seed}`}
      actions={
        <Group>
          <Button variant="default" size="xs" onClick={playAnother}>
            🎲 new random blend
          </Button>
          <Anchor component={Link} to="/" size="sm">
            ← today&rsquo;s puzzle
          </Anchor>
        </Group>
      }
    />
  );
}
